import React from 'react';
//css
import './Footer.css';

export default function Footer() {
  return (
    <>
      <div className='footer-container'>
        <div className='footer-content'>
          <p><a href='https://www.wiley.com/en-us/permissions/copyright'>Copyright @ 2000-2024</a> by John Wiley & Sons, Inc., or related companies. All rights reserved.</p>
        </div>
      </div>
    </>

  );
}
